import setHeadingLevel, { ValidHeadingLevels } from 'lib/sitecore/component-params';

export type HeadingTagProps = {
  children: React.ReactNode | React.ReactNode[];
  headingLevel: ValidHeadingLevels;
  offset?: number;
  [name: string]: unknown;
};

const HeadingTag = ({ headingLevel, offset, children, ...props }: HeadingTagProps): JSX.Element => {
  const Tag = setHeadingLevel(headingLevel, offset) as keyof JSX.IntrinsicElements;

  return <Tag {...props}>{children}</Tag>;
};

export default HeadingTag;
